import { sub, format } from 'date-fns'

// const DATE_FORMAT = "dd/MM/yyyy"
const DATE_FORMAT = "yyyy-MM-dd"

export const getLastActivityDate = (lastActivity: string) => {
    const today = new Date();
    const lastActivityNum = lastActivity.split(' ')[0];
    const lastActivityDuration = lastActivity.split(' ')[1];
    const duration = () => {
        switch (lastActivityDuration) {
            case 'day':
                return 'days'
            case 'days':
                return 'days'
            case 'week':
                return 'weeks'
            case 'weeks':
                return 'weeks'
            case 'month':
                return 'months'
            case 'months':
                return 'months'
            case 'year':
                return 'years'
            default:
                return 'days'
        }
    }
    return lastActivity !== '' ? format(sub(today, { [duration() as string]: lastActivityNum }), DATE_FORMAT) : ''
}